<h2 mat-dialog-title class="dialog-header">{{'user.userDetails'|traduccion}}
  <button mat-icon-button class="close-btn" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>
<mat-dialog-content class="dialog-content">
    <div appGridColumns [colsLg]="2" [colsMd]="1" [colsSm]="1" [colWidths]="[50, 50]">
            <mat-card>
                <h3>{{'user'|traduccion}} {{ user?.id }}</h3>
                <form [formGroup]="userForm">
                    <mat-form-field appearance="fill" class="full-width">
                        <mat-label>{{'user.name'|traduccion}}</mat-label>
                        <input matInput placeholder="name" formControlName="name">
                        <app-form-error [control]="userForm.get('name')" ></app-form-error>
                    </mat-form-field>
                    
                    <mat-form-field appearance="fill" class="full-width">
                        <mat-label>{{'user.username'|traduccion}}</mat-label>
                        <input matInput placeholder="username" formControlName="username">
                        <app-form-error [control]="userForm.get('username')" ></app-form-error>
                    </mat-form-field>

                    <mat-form-field appearance="fill" class="full-width">
                        <mat-label>{{'user.email'|traduccion}}</mat-label>
                        <input matInput placeholder="email" formControlName="email">
                        <app-form-error [control]="userForm.get('email')" ></app-form-error>
                    </mat-form-field>
                    
                    <mat-form-field appearance="fill" class="full-width">
                        <mat-label>{{'user.password'|traduccion}}</mat-label>
                        <input matInput type="text" placeholder="password" formControlName="password">
                        <app-form-error [control]="userForm.get('password')" ></app-form-error>
                        <button mat-icon-button matSuffix (click)="disabledPassword()" [attr.aria-label]="'Change password'">
                            <mat-icon>{{password?.enabled ? 'toggle_on' : 'toggle_off'}}</mat-icon>
                        </button>
                    </mat-form-field>

                    <mat-form-field appearance="fill" class="full-width">
                        <mat-label>{{'user.roles'|traduccion}}</mat-label>
                        <mat-select formControlName="roles" multiple>
                            <mat-option value="ROLE_ADMIN">ROLE_ADMIN</mat-option>
                            <mat-option value="ROLE_SUPERMANAGER">ROLE_SUPERMANAGER</mat-option>
                            <mat-option value="ROLE_MANAGER">ROLE_MANAGER</mat-option>
                            <mat-option value="ROLE_USER">ROLE_USER</mat-option>
                            <mat-option value="ROLE_LOCKER">ROLE_LOCKER</mat-option>
                            <mat-option value="ROLE_INSTALL">ROLE_INSTALL</mat-option>
                            <mat-option value="ROLE_COMMISSION_AGENT">ROLE_COMMISSION_AGENT</mat-option>
                        </mat-select>
                        <app-form-error [control]="userForm.get('roles')" ></app-form-error>
                    </mat-form-field>
                    
                </form>
                <p><strong>{{'user.createdAt'|traduccion}}:</strong> {{ user?.createdAt }}</p>
                <p><strong>{{'user.updatedAt'|traduccion}}:</strong> {{ user?.updatedAt }}</p>
                
            </mat-card>
            
            <mat-card>
                <h3>{{'customer.company'|traduccion}}</h3>
                <section class="example-section">
                    <mat-checkbox class="example-margin" [checked]="customerForm.enabled" (change)="toggleCustomerForm($event.checked)">{{'customer.form.enabled'|traduccion}}</mat-checkbox>
                    <p class="notice-alert" *ngIf="deleteCompanyData">{{'customer.deleteCompanyData'|traduccion}}</p>
                </section>
                <form [formGroup]="customerForm">
                    <mat-form-field appearance="fill" class="full-width">
                        <mat-label>{{'customer.companyName'|traduccion}}</mat-label>
                        <input matInput placeholder="companyName" formControlName="companyName">
                        <app-form-error [control]="customerForm.get('companyName')" ></app-form-error>
                    </mat-form-field>

                    <mat-form-field appearance="fill" class="full-width">
                        <mat-label>{{'customer.address'|traduccion}}</mat-label>
                        <input matInput placeholder="address" formControlName="address">
                        <app-form-error [control]="customerForm.get('address')" ></app-form-error>
                    </mat-form-field>

                    
                    <mat-form-field appearance="fill" class="full-width">
                        <mat-label>{{'customer.email'|traduccion}}</mat-label>
                        <input matInput placeholder="email" formControlName="email">
                        <app-form-error [control]="customerForm.get('email')" ></app-form-error>
                    </mat-form-field>
                    

                    <mat-form-field appearance="fill" class="full-width">
                        <mat-label>{{'customer.phone'|traduccion}}</mat-label>
                        <input matInput placeholder="phone" formControlName="phone">
                        <app-form-error [control]="customerForm.get('phone')" ></app-form-error>
                    </mat-form-field>
                    
                    
                    <mat-form-field appearance="fill" class="full-width">
                        <mat-label>{{'customer.typeCardId'|traduccion}}</mat-label>
                        <mat-select formControlName="typeCardId">
                            <mat-option value="DNI">DNI</mat-option>
                            <mat-option value="NIF">NIF</mat-option>
                        </mat-select>
                        <app-form-error [control]="customerForm.get('typeCardId')" ></app-form-error>
                    </mat-form-field>
                    
                    <mat-form-field appearance="fill" class="full-width">
                        <mat-label>{{'customer.cardId'|traduccion}}</mat-label>
                        <input matInput placeholder="cardId" formControlName="cardId">
                        <app-form-error [control]="customerForm.get('cardId')" ></app-form-error>
                    </mat-form-field>

                    <mat-form-field appearance="fill" class="full-width">
                        <mat-label>{{'customer.city'|traduccion}}</mat-label>
                        <input matInput placeholder="city" formControlName="city">
                        <app-form-error [control]="customerForm.get('city')" ></app-form-error>
                    </mat-form-field>

                    <mat-form-field appearance="fill" class="full-width">
                        <mat-label>{{'customer.country'|traduccion}}</mat-label>
                        <input matInput placeholder="country" formControlName="country">
                        <app-form-error [control]="customerForm.get('country')" ></app-form-error>
                    </mat-form-field>

                    <mat-form-field appearance="fill" class="full-width">
                        <mat-label>{{'customer.zipCode'|traduccion}}</mat-label>
                        <input matInput placeholder="zipCode" formControlName="zipCode">
                        <app-form-error [control]="customerForm.get('zipCode')" ></app-form-error>
                    </mat-form-field>

                    <!--
                    <mat-form-field appearance="fill" class="full-width">
                        <mat-label>{{'customer.userId'|traduccion}}</mat-label>
                        <input matInput placeholder="userId" formControlName="userId">
                    </mat-form-field>
                    -->
                </form>
                <p><strong>{{'customer.createdAt'|traduccion}}:</strong> {{ user?.createdAt }}</p>
                <p><strong>{{'customer.updatedAt'|traduccion}}:</strong> {{ user?.updatedAt }}</p>
            </mat-card>
    </div>

</mat-dialog-content>


<mat-dialog-actions class="dialog-footer">
    <button mat-raised-button color="primary" (click)="save()" [disabled]="userForm.invalid"><mat-icon>save</mat-icon>{{'Guardar'|traduccion}}</button>
    <button *ngIf="!userForm.invalid" mat-raised-button color="warn" (click)="delete()"><mat-icon>delete</mat-icon>{{'Eliminar'|traduccion}}</button>
</mat-dialog-actions>
